import React, { FunctionComponent } from "react"

export const TemplateIcon1: FunctionComponent = () => (
  <svg
    width="21"
    height="24"
    viewBox="0 0 21 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.43318 2.81641C7.08927 1.98456 8.0888 1.5 9.14573 1.5H11.8543C12.9112 1.5 13.9107 1.98456 14.5668 2.8164L17.6874 6.77284C20.1042 9.83703 20.1042 14.163 17.6874 17.2272L14.5668 21.1836C13.9107 22.0154 12.9112 22.5 11.8543 22.5H9.14573C8.0888 22.5 7.08928 22.0154 6.43318 21.1836L3.31261 17.2272C0.895797 14.163 0.895795 9.83703 3.31261 6.77284L6.43318 2.81641Z"
      stroke="#ED7B2A"
      stroke-width="3"
    />
  </svg>
)

export const TemplateIcon2: FunctionComponent = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.88624 3.16742C9.43523 2.0075 9.88485 1.70409 10.3226 1.58825C10.7672 1.47058 11.2328 1.47058 11.6774 1.58825C12.1152 1.70409 12.5648 2.0075 14.1138 3.16742L17.8396 5.9574C19.3832 7.11329 19.8104 7.46475 20.0609 7.87146C20.3155 8.28498 20.4665 8.76148 20.4968 9.25668C20.5268 9.74947 20.3765 10.3064 19.7882 12.1727L18.365 16.687C17.7755 18.5569 17.5804 19.0931 17.2807 19.4665C16.9798 19.8415 16.5956 20.1274 16.1668 20.3024C15.7483 20.4731 15.2176 20.5 13.3027 20.5H8.69731C6.78242 20.5 6.25167 20.4731 5.83322 20.3024C5.40439 20.1274 5.02025 19.8415 4.71931 19.4665L3.58996 20.373L4.71931 19.4665C4.4196 19.0931 4.22448 18.5569 3.63497 16.687L2.21183 12.1727C1.62349 10.3064 1.47316 9.74947 1.50324 9.25668C1.53347 8.76148 1.68451 8.28498 1.93913 7.87146C2.18956 7.46475 2.61679 7.11329 4.16041 5.9574L7.88624 3.16742Z"
      stroke="#6633FF"
      stroke-width="3"
    />
  </svg>
)

export const TemplateIcon3: FunctionComponent = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8346 3.09589L14.9954 7.30145C15.0044 7.3189 15.0135 7.33682 15.0229 7.35515C15.1262 7.55722 15.2551 7.80933 15.4324 8.03733C15.5865 8.2354 15.7646 8.41351 15.9627 8.56757C16.1907 8.74492 16.4428 8.8738 16.6449 8.97711C16.6632 8.98647 16.6811 8.99563 16.6985 9.00459L20.9041 11.1654C21.6125 11.5294 22.0504 11.7561 22.3472 11.9445C22.3794 11.965 22.4073 11.9835 22.4316 12C22.4073 12.0165 22.3794 12.035 22.3472 12.0555C22.0504 12.2439 21.6125 12.4706 20.9041 12.8346L16.6985 14.9954C16.6811 15.0044 16.6632 15.0135 16.6449 15.0229C16.4428 15.1262 16.1907 15.2551 15.9627 15.4324C15.7646 15.5865 15.5865 15.7646 15.4324 15.9627C15.2551 16.1907 15.1262 16.4428 15.0229 16.6449C15.0135 16.6632 15.0044 16.6811 14.9954 16.6985L12.8346 20.9041C12.4706 21.6125 12.2439 22.0504 12.0555 22.3472C12.035 22.3794 12.0165 22.4073 12 22.4316C11.9835 22.4073 11.965 22.3794 11.9445 22.3472C11.7561 22.0504 11.5294 21.6125 11.1654 20.9041L9.00459 16.6985C8.99563 16.6811 8.98647 16.6632 8.97711 16.6449C8.8738 16.4428 8.74492 16.1907 8.56757 15.9627C8.41351 15.7646 8.2354 15.5865 8.03733 15.4324C7.80933 15.2551 7.5572 15.1262 7.35513 15.0229C7.33681 15.0135 7.3189 15.0044 7.30145 14.9954L3.09589 12.8346C2.38751 12.4706 1.94961 12.2439 1.65282 12.0555C1.62064 12.035 1.59265 12.0165 1.56842 12C1.59265 11.9835 1.62064 11.965 1.65282 11.9445C1.94961 11.7561 2.38751 11.5294 3.09589 11.1654L7.30145 9.00459C7.3189 8.99563 7.33682 8.98647 7.35514 8.9771C7.55722 8.8738 7.80933 8.74492 8.03733 8.56757C8.23539 8.41351 8.41351 8.23539 8.56757 8.03733C8.74492 7.80933 8.87381 7.55721 8.97711 7.35513C8.98648 7.33681 8.99563 7.3189 9.00459 7.30145L11.1654 3.09589C11.5294 2.38751 11.7561 1.94961 11.9445 1.65282C11.965 1.62064 11.9835 1.59265 12 1.56842C12.0165 1.59265 12.035 1.62064 12.0555 1.65282C12.2439 1.94961 12.4706 2.38751 12.8346 3.09589Z"
      stroke="#1EB482"
      stroke-width="3"
      stroke-linejoin="round"
    />
  </svg>
)

export const TemplateIcon4: FunctionComponent = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.5"
      y="1.5"
      width="19"
      height="19"
      rx="6.5"
      stroke="#05AAFF"
      stroke-width="3"
    />
  </svg>
)

export const TemplateIcon5: FunctionComponent = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.21416 7.81213C8.22807 6.02234 8.9389 4.77057 9.55357 3.88389C10.174 2.98887 10.5587 2.67801 10.8319 2.55405C11.5761 2.21636 12.4239 2.21636 13.1681 2.55405C13.4413 2.67801 13.826 2.98887 14.4464 3.88389C15.0611 4.77057 15.7719 6.02234 16.7858 7.81213L19.8313 13.1881C20.8451 14.9777 21.5536 16.2313 21.9999 17.2176C22.449 18.2102 22.5264 18.7145 22.4933 19.0352C22.4057 19.8846 21.9694 20.6476 21.3049 21.1397C21.063 21.3188 20.6115 21.5009 19.5477 21.6003C18.4902 21.6992 17.0744 21.7008 15.0455 21.7008H8.95452C6.92555 21.7008 5.50979 21.6992 4.45235 21.6003C3.38846 21.5009 2.93701 21.3188 2.69514 21.1397C2.03062 20.6476 1.59427 19.8846 1.50668 19.0352C1.47361 18.7145 1.55096 18.2102 2.00012 17.2176C2.44645 16.2313 3.15488 14.9777 4.16868 13.1881L7.21416 7.81213Z"
      stroke="#EC4747"
      stroke-width="3"
    />
  </svg>
)
